import { Grid } from '@mui/material';
import { useEffect, useRef } from 'react';
import { AddNewComment } from './AddNewComment';
import { CommentList } from './CommentList';

export interface CommentContainerProps {
  comments?: any[];
  commentsLoading?: boolean;
  createComment?: (values: any) => void;
  markRead?: Function;
  recipients?: any;
  type?: string;
}

export const CommentContainer = ({
  comments = [],
  commentsLoading = false,
  createComment = (values: any) => {},
  markRead = () => {},
  type,
  recipients,
}: CommentContainerProps) => {
  const messagesEndRef = useRef<HTMLElement>(null);
  const scrollToBottom = () => {
    if (messagesEndRef && messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [comments]);
  useEffect(() => {
    markRead();
  }, []);

  return (
    <Grid
      container
      wrap="nowrap"
      spacing={0}
      justifyItems={'flex-start'}
      alignItems={'stretch'}
      direction={'column'}
      sx={{ p: 0, m: 0, height: '100%' }}
    >
      <Grid item flexGrow={9}>
        <CommentList comments={comments} commentsLoading={commentsLoading} />
      </Grid>
      <AddNewComment
        createComment={createComment}
        recipients={recipients}
        type={type}
      />

      <span ref={messagesEndRef}></span>
    </Grid>
  );
};
